import { UseCasesHub } from '@/containers/usecases';

export default function UseCasesRoute() {
  return <UseCasesHub />;
}
